import React from 'react'

import { Button, Icon } from '../../../components'
import { drawingTools } from '../drawingTools'
import { DrawingTool } from '../interfaces'

type ToolButtonProps = {
  onClick: () => void
  activeTool: DrawingTool
}

export default function ToolButton({ activeTool, onClick }: ToolButtonProps) {
  return (
    <Button appearance="square" onClick={onClick} active={true} theme="chipTransparent" size="medium">
      <Icon name={drawingTools[activeTool].icon} width={32} className="shrink-0" />
    </Button>
  )
}
